export default __webpack_public_path__ + "static/media/bannerbg.9e1a5aad.png";